import React from 'react'

import styled from 'styled-components'

import { EmbedIntegrationsDescription } from 'components/EmbedIntegrationsDescription'
import PlaceholderRemoverForm from 'components/PlaceholderRemoverForm'
import GenerateEmbedCodeModal from 'components/GenerateEmbedCodeModal'
import { EmailPreview } from 'components/EmailPreview/EmailPreview'
import EmbedNPSStyleForm from 'components/EmbedNPSStyleForm'
import { HelpdeskIntegration } from 'organisms/HelpdeskIntegration'
import { GenerateEmbedCodeForm } from 'organisms/GenerateEmbedCodeForm'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import * as R from 'ramda'

const StyledContainer = styled.div`
  margin-top: 2rem;
  border-radius: 4px;
  background-color: #f6f6f6;
  padding: 1.625em !important;
`

/**
 *
 * @param {object} props
 * @param {object} props.primaryQuestion
 * @param {object} props.publishSettings
 * @param {string} props.selectedIntegration
 * @param {object} props.surveyConfiguration
 * @param {string} props.embedStyleType
 * @param {function} props.setEmbedStyleType
 * @param {boolean} props.showPlaceholderRemover
 * @param {boolean} props.isRemovePlaceholder
 * @param {function} props.setIsRemovePlaceholder
 * @param {object} [props.language]
 * @param {object} props.placeholders
 * @param {object} props.customField
 * @param {function} [props.onUpdateGenericEmbedPlaceholdersAndCustomFields]
 */
export function NPSEmbed({
  primaryQuestion,
  publishSettings,
  selectedIntegration,
  surveyConfiguration,
  embedStyleType,
  setEmbedStyleType,
  showPlaceholderRemover,
  isRemovePlaceholder,
  setIsRemovePlaceholder,
  placeholders,
  customField,
  onUpdateGenericEmbedPlaceholdersAndCustomFields,
}) {
  // CES is routed through this component alongside NPS. NPS is value-keyed
  // and out of scope for PET-1967; only CES honors settings.setups.choiceOrder.
  const isCES = primaryQuestion.metric === 'CES'
  const isReverseOrder = isCES ? Boolean(publishSettings.choiceOrder) : false
  const ratingIconDisplayOptions = {
    isRemovePlaceholder,
    isReverseOrder,
  }
  const emailPreviewIframeHeight = 125
  const generateEmbedCodeModalProps = {
    surveyToken: publishSettings.surveyToken,
    currentSelectedIntegration: selectedIntegration,
    description: surveyConfiguration.embedModal.content,
    linkText: surveyConfiguration.embedModal.linkText,
    linkUrl: surveyConfiguration.embedModal.linkUrl,
    isVisualToggleShown: surveyConfiguration.isShowVisual,
    primaryQuestion,
    embedStyleType,
    ratingIconDisplayOptions,
    placeholders,
    emailPreviewIframeHeight,
    customField,
    onUpdateGenericEmbedPlaceholdersAndCustomFields,
  }

  return (
    <React.Fragment>
      <div className="ui stackable grid">
        <div className="seven wide column">
          <EmbedIntegrationsDescription
            label={surveyConfiguration.label}
            description={surveyConfiguration.overview}
          />
          <EmbedNPSStyleForm
            className="mt4"
            embedStyleType={embedStyleType}
            onChange={setEmbedStyleType}
          />
          {showPlaceholderRemover && (
            <PlaceholderRemoverForm
              className="mt4"
              isRemovePlaceholder={isRemovePlaceholder}
              onChange={setIsRemovePlaceholder}
            />
          )}
          <GenerateEmbedCodeModal {...generateEmbedCodeModalProps} className="mt4" />
        </div>
        <div className="nine wide column">
          <EmailPreview
            surveyToken={publishSettings.surveyToken}
            placeholders={placeholders}
            embedStyleType={embedStyleType}
            primaryQuestion={primaryQuestion}
            currentSelectedIntegration={selectedIntegration}
            ratingIconDisplayOptions={ratingIconDisplayOptions}
            emailPreviewIframeHeight={emailPreviewIframeHeight}
            customField={generateEmbedCodeModalProps.customField}
          />
        </div>
      </div>
      <HelpdeskIntegrationSection
        generateEmbedCodeModalProps={generateEmbedCodeModalProps}
        selectedIntegration={selectedIntegration}
        publishSettings={publishSettings}
      />
    </React.Fragment>
  )
}

function HelpdeskIntegrationSection({
  selectedIntegration,
  publishSettings,
  generateEmbedCodeModalProps,
}) {
  const { surveyId } = useParams()

  function mapState({ data: { surveys } }) {
    return {
      isUpdateTicketTagsAndCommentActive: R.path(
        ['settings', 'updateTicketTagsAndComment', 'isActive'],
        surveys.entity[surveyId]
      ),
    }
  }
  const { isUpdateTicketTagsAndCommentActive } = useSelector(mapState)

  const isZendeskAuthenticated =
    selectedIntegration === 'zendesk' && isUpdateTicketTagsAndCommentActive

  if (isZendeskAuthenticated) {
    return (
      <div className="ui stackable grid">
        <StyledContainer className="wide column">
          <HelpdeskIntegration
            selectedIntegration={selectedIntegration}
            surveyToken={publishSettings.surveyToken}
          />
        </StyledContainer>
      </div>
    )
  }

  if (selectedIntegration === 'generic_embed') {
    return (
      <div className="ui stackable grid">
        <StyledContainer className="wide column">
          <HelpdeskIntegration
            selectedIntegration={selectedIntegration}
            surveyToken={publishSettings.surveyToken}
          />
          <GenerateEmbedCodeForm
            {...publishSettings}
            handleChangePlaceHolders={publishSettings.handleChangePlaceHolders}
          />
          <GenerateEmbedCodeModal {...generateEmbedCodeModalProps} className="mt2" />
        </StyledContainer>
      </div>
    )
  }

  return null
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/EmbedSurveyV2/NPSEmbed.js